const getSigningStatusClassName = status => {
  switch (status) {
    case 1: // SigningEmpty
      return 'fa fa-circle-o';
    case 2: // SigningNeeded
      return 'fa fa-circle text-orange';
    case 3: // SigningRevoked
      return 'fa fa-stop-circle';
    case 4: // SigningExpired
      return 'fa fa-clock-o text-danger';
    case 10: // SigningPending
      return 'fa fa-circle text-blue';
    case 11: // SigningFailed
      return 'fa fa-times-circle text-danger';
    case 12: // SigningRejected
      return 'fa fa-minus-circle text-danger';
    case 20: // SigningCompleted
    case 21: // SigningCompletedOriginal
      return 'fa fa-check-circle text-success';
    default:
      return '';
  }
};
export default getSigningStatusClassName;
